import type { PayloadAction, UnknownAction } from '@reduxjs/toolkit';

import { router } from '@/routes/appRoutes';
import { fetchSixDetailMetaAndFilesThunk } from '@/store/thunks/sixDetail/fetchMetaAndFilesThunk';
import { initSixDetailThunk } from '@/store/thunks/sixDetail/getInitialDetailThunk';
import { logoutThunk } from '@/store/thunks/auth/logoutThunk';
import {
  isIncomingMessageOfType,
  type IncomingMessageOfType,
} from '@/store/listeners/poc/incomingMessageMatchers';
import { cancelAllFileRefreshPolls } from '@/store/listeners/poc/fileRefreshCoordinator';
import type { AppStartListening } from '@/store/listeners/types';

export function registerIncomingFileRefreshListeners(
  startAppListening: AppStartListening
): void {
  startAppListening({
    matcher: (action: UnknownAction): action is PayloadAction<IncomingMessageOfType<'refreshFiles'>> =>
      isIncomingMessageOfType(action, 'refreshFiles'),
    effect: async(action, listenerApi) => {
      const { sixId } = action.payload.result.data;
      if (router.state.location.pathname !== `/app/sixes/${sixId}`) return;
      await listenerApi.dispatch(fetchSixDetailMetaAndFilesThunk(sixId)).unwrap();
    },
  });

  startAppListening({
    matcher: (action: UnknownAction): action is PayloadAction<IncomingMessageOfType<'refreshSix'>> =>
      isIncomingMessageOfType(action, 'refreshSix'),
    effect: (action, listenerApi) => {
      const { sixId } = action.payload.result.data;
      if (router.state.location.pathname !== `/app/sixes/${sixId}`) return;
      void listenerApi.dispatch(initSixDetailThunk(sixId));
    },
  });

  startAppListening({
    actionCreator: logoutThunk.pending,
    effect: () => {
      cancelAllFileRefreshPolls();
    },
  });
}
